package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository
import kotlinx.coroutines.flow.Flow

class GetAppointmentByIdUseCase(
    private val repository: AppointmentRepository
) {
    operator fun invoke(appointmentId: String): Flow<Appointment?> {
        return repository.getAppointmentById(appointmentId)
    }
}
